import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate, UrlTree} from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import {OidcSecurityService} from 'angular-auth-oidc-client';


@Injectable({providedIn: 'root'})
export class ManageLoginGuard implements CanActivate {
  constructor(private router: Router, private oidcSecurityService: OidcSecurityService) {}

  
  canActivate(): Observable<boolean | UrlTree> {
    
    // Check if the user is authenticated
    return this.oidcSecurityService.checkAuth().pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated.isAuthenticated) {
          return true; // Allow access
        } else {
          // Redirect to the login page if not authenticated
          return this.router.createUrlTree(['/doctor-panel/dashboard']);
        }
      })
    );
  }
}


//   public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
//     if (this.oidcSecurityService.isAuthenticated() == false || this.cookieService.get('token') == '' || this.cookieService.get('token') == undefined) {
//       return true;
//     } else if (this.cookieService.get('token') != null && this.cookieService.get('token') != '' && this.cookieService.get('token') != undefined) {
//       this.router.navigate(['/user']);
//       return false;
//     } else {
//       this.router.navigate(['/user'])
//       return false;
//     }
//   }
// }